import React, { useMemo } from "react"
import classNames from "classnames"
import { SafeAreaView } from "@hg/layouts"

import SKLandReturn from "@/components/SKLandReturn"
import { adapter } from "@/utils/sdk"

import styles from "./index.module.less"

const { returnButton } = adapter.ui

interface LogoProps {
    safeArea?: boolean
    className?: string
}

const Logo: React.FC<LogoProps> = ({ safeArea = true, className }) => {
    const sklandReturn = useMemo(() => {
        return returnButton ? <SKLandReturn className={styles.return} /> : null
    }, [])

    if (safeArea) {
        return (
            <SafeAreaView
                mode="margin"
                edges={["left"]}
                className={classNames(styles.logo, className)}
            >
                {sklandReturn}
            </SafeAreaView>
        )
    }

    return (
        <div className={classNames(styles.logo, className)}>{sklandReturn}</div>
    )
}

export default Logo
